import * as React from 'react';
import MuiTableRow, {TableRowProps} from 'original/TableRow/TableRow';
import {createStyles, Theme, WithStyles, withStyles} from '../styles';
import * as classNames from 'classnames';
import {AlertProps} from '../Alert';

export * from 'original/TableRow/TableRow';

export interface ExtendedTableRowProps extends TableRowProps {
  statusColor?: AlertProps['color'];
}

const styles = (theme: Theme) =>
  createStyles({
    rootStatusDefault: {
      borderLeft: `${theme.spacing(0.5)}px solid`,
      borderLeftColor: theme.palette.divider,
    },
    rootStatusPrimary: {
      borderLeft: `${theme.spacing(0.5)}px solid`,
      borderLeftColor: theme.palette.primary.main,
    },
    rootStatusSecondary: {
      borderLeft: `${theme.spacing(0.5)}px solid`,
      borderLeftColor: theme.palette.secondary.main,
    },
    rootStatusError: {
      borderLeft: `${theme.spacing(0.5)}px solid`,
      borderLeftColor: theme.palette.error.main,
    },
  });

export default withStyles(styles)((({
  statusColor,
  className,
  classes: {rootStatusDefault, rootStatusPrimary, rootStatusSecondary, rootStatusError, ...otherClasses},
  ...props
}) => {
  return (
    <MuiTableRow
      className={classNames(className, {
        [rootStatusDefault]: statusColor === 'default',
        [rootStatusPrimary]: statusColor === 'primary',
        [rootStatusSecondary]: statusColor === 'secondary',
        [rootStatusError]: statusColor === 'error',
      })}
      classes={otherClasses}
      {...props}
    />
  );
}) as React.SFC<ExtendedTableRowProps & WithStyles<typeof styles>>);
